import { createState } from "../store/zustand_store";

export const useEditSeatsTrack = createState({
  isEditSeatsClicked: false,
});
